import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React from "react";
import { useMobileSecondaryNavContent } from "utilities/contexts/use-mobile-secondary-nav/use-mobile-secondary-nav-content";
import { t } from "utilities/localization-utils";

const BASE_CLASS_NAME = "c-bookview-search-button";

const BookviewSearchButton: React.FC = () => {
    const { toggleBookviewSearchPanel } = useMobileSecondaryNavContent();

    return (
        <div className={BASE_CLASS_NAME}>
            <Button
                size={ButtonSizes.Small}
                style={ButtonStyles.TertiaryAlt}
                onClick={toggleBookviewSearchPanel}>
                <Icon size={IconSizes.Large} type={Icons.Search} />
                <span className={`${BASE_CLASS_NAME}__text`}>
                    {t("search")}
                </span>
            </Button>
        </div>
    );
};

export default BookviewSearchButton;
